import { Group, SegmentedControl, Select, Text } from '@byecode/ui'
import { type DataSourceAbstract, Order } from '@lighthouse/core'
import { FieldIconTypeMap, ListItem4ByecodeUi, SORT_OPTIONS } from '@lighthouse/shared'
import { useMemo } from 'react'
import { Controller, useFormContext } from 'react-hook-form'

interface Props {
    dataSource: DataSourceAbstract
}

export const MultiDimensionalFieldSelector = ({ dataSource }: Props) => {
    const { control, watch } = useFormContext()
    const rowDimensionSortField = watch('multiDimensionalConfig.rowDimensionSortField')
    const columnDimensionSortField = watch('multiDimensionalConfig.columnDimensionSortField')

    const options = useMemo(() => {
        return Object.values(dataSource.schema)
            .filter(item => item.innerType === 'TEXT' || item.innerType === 'NUMBER' || item.innerType === 'DATE')
            .map(item => ({
                label: item.name,
                value: item.id,
                icon: FieldIconTypeMap[item.type]
            }))
    }, [dataSource.schema])

    const hasValidRowDimensionSortField = useMemo(() => {
        return rowDimensionSortField && dataSource.schema[rowDimensionSortField]
    }, [rowDimensionSortField, dataSource.schema])

    const hasValidColumnDimensionSortField = useMemo(() => {
        return columnDimensionSortField && dataSource.schema[columnDimensionSortField]
    }, [columnDimensionSortField, dataSource.schema])

    return (
        <Group label="维度设置">
            <ListItem4ByecodeUi alignItems="center" justifyContent="space-between">
                <Text>行维度</Text>
                <Controller
                    name="multiDimensionalConfig.rowDimension"
                    control={control}
                    render={({ field }) => {
                        return (
                            <Select
                                style={{ width: 180 }}
                                placeholder="请选择字段"
                                options={options}
                                value={field.value}
                                onChange={field.onChange}
                                searchable
                            />
                        )
                    }}
                />
            </ListItem4ByecodeUi>
            <ListItem4ByecodeUi alignItems="center" justifyContent="space-between">
                <Text>行维度排序依据</Text>
                <Controller
                    name="multiDimensionalConfig.rowDimensionSortField"
                    control={control}
                    render={({ field }) => {
                        return (
                            <Select
                                style={{ width: 180 }}
                                placeholder="请选择字段"
                                options={options}
                                value={field.value}
                                onChange={field.onChange}
                                searchable
                                clearable
                            />
                        )
                    }}
                />
            </ListItem4ByecodeUi>
            {hasValidRowDimensionSortField && (
                <ListItem4ByecodeUi alignItems="center" justifyContent="space-between">
                    <Text />
                    <Controller
                        name="multiDimensionalConfig.rowDimensionSortMode"
                        control={control}
                        defaultValue={Order.ASC}
                        render={({ field }) => {
                            return (
                                <SegmentedControl
                                    style={{ width: 180 }}
                                    fullWidth
                                    data={SORT_OPTIONS}
                                    value={field.value}
                                    onChange={field.onChange}
                                />
                            )
                        }}
                    />
                </ListItem4ByecodeUi>
            )}

            <ListItem4ByecodeUi alignItems="center" justifyContent="space-between">
                <Text>列维度</Text>
                <Controller
                    name="multiDimensionalConfig.columnDimension"
                    control={control}
                    render={({ field }) => {
                        return (
                            <Select
                                style={{ width: 180 }}
                                placeholder="请选择字段"
                                options={options}
                                value={field.value}
                                onChange={field.onChange}
                                searchable
                            />
                        )
                    }}
                />
            </ListItem4ByecodeUi>
            <ListItem4ByecodeUi alignItems="center" justifyContent="space-between">
                <Text>列维度排序依据</Text>
                <Controller
                    name="multiDimensionalConfig.columnDimensionSortField"
                    control={control}
                    render={({ field }) => {
                        return (
                            <Select
                                style={{ width: 180 }}
                                placeholder="请选择字段"
                                options={options}
                                value={field.value}
                                onChange={field.onChange}
                                searchable
                                clearable
                            />
                        )
                    }}
                />
            </ListItem4ByecodeUi>
            {hasValidColumnDimensionSortField && (
                <ListItem4ByecodeUi alignItems="center" justifyContent="space-between">
                    <Text />
                    <Controller
                        name="multiDimensionalConfig.columnDimensionSortMode"
                        control={control}
                        defaultValue={Order.ASC}
                        render={({ field }) => {
                            return (
                                <SegmentedControl
                                    style={{ width: 180 }}
                                    fullWidth
                                    data={SORT_OPTIONS}
                                    value={field.value}
                                    onChange={field.onChange}
                                />
                            )
                        }}
                    />
                </ListItem4ByecodeUi>
            )}
        </Group>
    )
}
